import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import uenlogo from '../../assets/uenlogo.png';
import './style.css';
import { removeAllLocalStorage } from '../../utils';
import ButtonHome from '../../Page/Home2/components/ButtonHome';

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const user = localStorage.getItem("user");
    const state = user ? JSON.parse(user) : null;
    const isAuth = !!state?.auth;

    useEffect(() => {
        setIsMenuOpen(false);
    }, [location.pathname]);

    const sair = () => {
        removeAllLocalStorage();
        window.location.reload();
    };

    const handleCloseMenu = () => {
        if (isMenuOpen) setIsMenuOpen(false);
    };

    return (
        <header className="headerContainer">
            <div className="headerContent">
                {/* 1. Lado Esquerdo: Logo */}
                <div className="logoArea" onClick={() => navigate('/')}>
                    <img src={uenlogo} alt="Logo UEN" className="logoImage" />
                </div>

                {/* 2. Centro: Navegação (Links) */}
                <nav className={`navLinks ${isMenuOpen ? 'open' : ''}`}>
                    <div className="navGroup" onClick={handleCloseMenu}>
                        <div className="mobileMenuLogo">
                            <img src={uenlogo} alt="Logo UEN" />
                        </div>

                        {isAuth ? (
                            <>
                                <button className="linkButton" style={{ '--i': 1 }} onClick={() => navigate('/carteiraVisualizar')}>
                                    Visualizar Carteira
                                </button>
                                <button className="linkButton" style={{ '--i': 2 }} onClick={() => window.open(`/validar/${state.cpf}`, '_blank')}>
                                    Validador
                                </button>
                                {/* Botão de Sair exclusivo para o menu Mobile */}
                                <div className="mobileActionWrapper">
                                    <ButtonHome onClick={sair} text="Sair" />
                                </div>
                            </>
                        ) : (
                            <>
                               {/*  <button className="linkButton" style={{ '--i': 1 }} onClick={() => navigate('/usuarios/metricas')}>
                                    Como pedir carteirinha
                                </button> */}
                                <button
                                    className="linkButton"
                                    style={{ '--i': 1 }}
                                    onClick={() => { handleCloseMenu(); navigate('/validacao'); }}
                                >
                                    Validação
                                </button>
                                <button
                                    className="linkButton"
                                    style={{ '--i': 2 }}
                                    onClick={() => {
                                        handleCloseMenu();

                                        if (location.pathname === '/') {
                                            // Se já estiver na Home, apenas faz o scroll
                                            const section = document.getElementById('duvidascomp');
                                            if (section) {
                                                section.scrollIntoView({ behavior: 'smooth' });
                                            }
                                        } else {
                                            // Se estiver em outra página, navega para a home com o hash
                                            navigate('/#duvidascomp');
                                        }
                                    }}
                                >
                                    Dúvidas Frequentes
                                </button>
                                <button className="linkButton" style={{ '--i': 3 }} onClick={() => navigate('/termosdeuso')}>
                                    Termos de uso
                                </button>
                                {/* Botão de Login exclusivo para o menu Mobile */}
                                <div className="mobileActionWrapper">
                                    <ButtonHome onClick={() => navigate('/login')} text="Faça seu Login!" />
                                </div>
                            </>
                        )}
                    </div>
                </nav>

                {/* 3. Lado Direito: Botão Desktop */}
                <div className="desktopOnlyAction">
                    {isAuth ? (
                        <ButtonHome onClick={sair} text="Sair" />
                    ) : (
                        <ButtonHome onClick={() => navigate('/login')} text="Faça seu Login!" />
                    )}
                </div>

                {/* Menu Hamburguer */}
                <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </div>
            </div>
        </header>
    );
}